import { createRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { authenticatedRoute } from '../_authenticated';

const DashboardPage = lazy(() =>
  import('@/features/dashboard/components/DashboardPage').then((m) => ({
    default: m.DashboardPage,
  })),
);

export const dashboardRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/dashboard',
  component: DashboardPage,
});
